import React from 'react';
import Icon from '../../../components/AppIcon';

const ShipmentHeader = ({ reference, status }) => {
  return (
    <div className="bg-card border border-border rounded-lg p-6 mb-6">
      <div className="flex items-start justify-between flex-wrap gap-4">
        <div className="flex-1 min-w-0">
          <div className="flex items-center space-x-2 mb-2">
            <Icon name="Package" size={24} className="text-primary flex-shrink-0" />
            <h1 className="text-2xl font-bold text-foreground truncate">
              Suivi de colis
            </h1>
          </div>
          <div className="flex items-center space-x-3 mt-3">
            <span className="text-sm text-muted-foreground">Référence:</span>
            <span className="text-lg font-semibold text-primary bg-primary/10 px-3 py-1 rounded-md">
              {reference}
            </span>
          </div>
        </div>
        <div className="flex items-center space-x-2">
          <a
            href="https://wa.me/33651988621"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center space-x-2 px-4 py-2 bg-success/10 text-success rounded-md hover:bg-success/20 transition-smooth"
          >
            <Icon name="MessageCircle" size={20} />
            <span className="text-sm font-medium">06 51 98 86 21</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default ShipmentHeader;